import type { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { RoutePath } from '../../config';
import { useAuthContext } from '../../hooks';
import { ClientInnerPageLayout } from '../../layouts';

export const ClientProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const { isAuthorized, isClient, isLoading } = useAuthContext();

  // Пока идёт проверка авторизации — сразу показываем каркас страницы:
  // внутри у экранов свои скелетоны, отдельный спиннер больше не нужен.
  if (isLoading) {
    return <ClientInnerPageLayout>{children}</ClientInnerPageLayout>;
  }

  if (!isAuthorized || !isClient) {
    return <Navigate to={RoutePath.ClientLogin} replace />;
  }

  return <ClientInnerPageLayout>{children}</ClientInnerPageLayout>;
};
